module.exports = __webpack_public_path__ + "img/pdf.8e3c4619.png";